/* eslint-disable react/no-multi-comp */
import React from 'react';
import { useTheme } from 'styled-components';
import Container from "../Container";
import { Home } from "../Icon";
import Text from "../Text";
import { StyledAuthHeaderContentContainer, StyledAuthHeaderContainer, StyledAuthHeaderCustomerDetailContainer, StyledAuthHeaderLogoutContainer, StyledAuthHeaderHomeButtonContainer, StyledAuthHeaderButtonContainer } from "./styled";
var AuthHeader = function AuthHeader(_ref) {
  var _ref$fullName = _ref.fullName,
    fullName = _ref$fullName === void 0 ? '' : _ref$fullName,
    _ref$homeButton = _ref.homeButton,
    homeButton = _ref$homeButton === void 0 ? false : _ref$homeButton,
    _ref$lastLoggedInText = _ref.lastLoggedInText,
    lastLoggedInText = _ref$lastLoggedInText === void 0 ? '' : _ref$lastLoggedInText,
    _ref$onHomeClick = _ref.onHomeClick,
    onHomeClick = _ref$onHomeClick === void 0 ? function () {} : _ref$onHomeClick,
    _ref$onLogoutClick = _ref.onLogoutClick,
    onLogoutClick = _ref$onLogoutClick === void 0 ? function () {} : _ref$onLogoutClick,
    width = _ref.width;
  var theme = useTheme() || {};
  return /*#__PURE__*/React.createElement(StyledAuthHeaderContainer, {
    className: "csl-header__auth-container"
  }, /*#__PURE__*/React.createElement(Container, {
    width: width
  }, /*#__PURE__*/React.createElement(StyledAuthHeaderContentContainer, {
    className: "csl-header__auth-content-container"
  }, /*#__PURE__*/React.createElement(StyledAuthHeaderCustomerDetailContainer, {
    className: "csl-header__auth-customer-detail-container"
  }, /*#__PURE__*/React.createElement(Text, {
    as: "p",
    size: "s1",
    weight: "bold"
  }, fullName), /*#__PURE__*/React.createElement(Text, {
    size: "s1"
  }, lastLoggedInText)), /*#__PURE__*/React.createElement(StyledAuthHeaderLogoutContainer, {
    className: "csl-header__auth-logout-container"
  }, homeButton && /*#__PURE__*/React.createElement(StyledAuthHeaderHomeButtonContainer, {
    "aria-label": "home",
    className: "csl-header__auth-home-button",
    onClick: onHomeClick
  }, /*#__PURE__*/React.createElement(StyledAuthHeaderButtonContainer, null, /*#__PURE__*/React.createElement(Home, {
    color: "inherit",
    iconSize: "lg",
    size: "s2"
  }))), /*#__PURE__*/React.createElement(StyledAuthHeaderHomeButtonContainer, {
    className: "csl-header__auth-logout-button",
    onClick: onLogoutClick
  }, /*#__PURE__*/React.createElement(StyledAuthHeaderButtonContainer, {
    className: "csl-header__auth-logout-button-container"
  }, /*#__PURE__*/React.createElement(Text, {
    className: "csl-header__auth-logout-button",
    color: "inherit",
    size: "s1",
    tabIndex: -1,
    weight: theme.button_config_font_weight
  }, theme.header_config_logout_text || 'Log off')))))));
};
AuthHeader.displayName = 'AuthHeader';
export default AuthHeader;